import React from 'react';
import { Input, InputGroup, Button, InputGroupText } from 'reactstrap';
import { searchIconWithLongTail } from '@src/assets/svg';
import { AppIcon } from '@common';

import './style.scss';
/**
 * APP SEARCH FIELD
 * @param {Object} props
 * @param {Boolean} props.iconStart
 * @param {Function} props.handleSearchCallBack
 * @returns
 */
const AppSearchField = (props) => {
  const [search, setSearch] = React.useState('');

  /**
   * HANDLE SEARCH FIELD
   * @param {string} e
   * @returns
   */
  const handleSearch = (e) => {
    setSearch(e.target.value);
    if (props?.handleSearchCallBack) props.handleSearchCallBack(e.target.value);
  };

  return (
    <InputGroup
      className={`search-input ${props.iconStart ? 'iconStart' : ''}`}
    >
      <Input
        type="text"
        value={search}
        onChange={handleSearch}
        placeholder={'Search'}
      />
      {/* <Button> */}
      <InputGroupText>
        <AppIcon icon={searchIconWithLongTail} />
      </InputGroupText>
      {/* </Button> */}
    </InputGroup>
  );
};

export default AppSearchField;
